import React, { useState, useEffect } from 'react';
import { FaTimes, FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import IconPicker, { getIconComponent } from './IconPicker';

const UnitTypeForm = ({ type, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: type?.name || '',
    icon: type?.icon || '',
    color: type?.color || '#000000'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit({
      ...formData,
      id: type?.id
    });
  };

  return (
    <div className="org-chart-modal-overlay">
      <div className="org-chart-modal" style={{ width: '400px' }}>
        <div className="org-chart-modal-header">
          <h3>{type?.id ? 'Edit Unit Type' : 'Add New Unit Type'}</h3>
          <button className="org-chart-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="org-chart-modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label>Color</label>
              <div className="color-picker-container">
                <input
                  type="color"
                  className="form-control"
                  value={formData.color}
                  onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                  style={{ width: '100px', height: '40px' }}
                />
              </div>
            </div>
            <div className="form-group">
              <label>Icon</label>
              <IconPicker
                selectedIcon={formData.icon}
                onIconSelect={(icon) => setFormData({ ...formData, icon: icon })}
                isInvalid={false}
              />
            </div>
            <div className="org-chart-modal-footer">
              <button
                type="button"
                className="org-chart-btn org-chart-btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="org-chart-btn org-chart-btn-primary">
                {type?.id ? 'Update' : 'Add'} Unit Type
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const UnitTypesModal = ({ isOpen, onClose, unitTypes, onSave, onDelete }) => {
  const [editingType, setEditingType] = useState(null);

  const handleSubmit = async (formData) => {
    try {
      await onSave(formData);
      setEditingType(null);
      toast.success(formData.id ? 'Unit type updated successfully' : 'Unit type created successfully');
    } catch (error) {
      toast.error('Error saving unit type');
    }
  };

  const handleDelete = async (typeId) => {
    if (window.confirm('Are you sure you want to delete this unit type?')) {
      try {
        await onDelete(typeId);
        toast.success('Unit type deleted successfully');
      } catch (error) {
        toast.error('Error deleting unit type');
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="org-chart-modal-overlay">
      <div className="org-chart-modal">
        <div className="org-chart-modal-header">
          <h3>Manage Unit Types</h3>
          <button className="org-chart-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="org-chart-modal-body">
          <div className="unit-types-list">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="m-0">Unit Types</h4>
              <button
                className="org-chart-btn org-chart-btn-primary"
                onClick={() => setEditingType({})}
              >
                <FaPlus /> Add New Type
              </button>
            </div>
            {unitTypes.map((type) => (
              <div key={type.id} className="unit-type-item p-3 border rounded mb-2 d-flex align-items-center">
                <div className="color-preview me-2" style={{ 
                  backgroundColor: type.color,
                  width: '20px',
                  height: '20px',
                  borderRadius: '4px'
                }} />
                <div className="me-2">{getIconComponent(type.icon)}</div>
                <div className="flex-grow-1">{type.name}</div>
                <div className="unit-type-actions">
                  <button
                    className="org-chart-btn org-chart-btn-secondary me-2"
                    onClick={() => setEditingType(type)}
                  >
                    <FaEdit />
                  </button>
                  <button
                    className="org-chart-btn org-chart-btn-danger"
                    onClick={() => handleDelete(type.id)}
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {editingType && (
        <UnitTypeForm
          type={editingType.id ? editingType : null}
          onSubmit={handleSubmit}
          onClose={() => setEditingType(null)}
        />
      )}
    </div>
  );
};

export default UnitTypesModal; 